/* @flow weak */
import { FormDaySelect, FormMonthSelect, FormYearSelect } from 'components/FormDateInputs.jsx';
import { STRIPE_ACCOUNT_TYPE_INDIVIDUAL } from 'entities/PaymentAccount';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import EncryptionNotice from 'components/EncryptionNotice.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import FormSelect from 'components/FormSelect.jsx';
import Label from 'components/Label.jsx';
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import React from 'react';
import ToastActions from 'actions/ToastActions';
import USState from 'lib/USState';

import './styles/IdentityVerificationView.scss';

const COUNTRY_CODE = 'US';

const IdentityVerificationView = React.createClass({
  propTypes: {
    onVerified: React.PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      disabled: true,
      loading: false,
    };
  },

  handleFormSubmit(value, resetForm, invalidateForm) {
    const onFailure = (error) => {
      ToastActions.showAPIError(error);

      const errors = {};
      for (const field of error.field_errors) {
        errors[field['field_name']] = field.messages.join(', ');
      }
      invalidateForm(errors);
    };

    value.type = STRIPE_ACCOUNT_TYPE_INDIVIDUAL;
    value['address'] = value['address'] || {};
    value['address'].country = COUNTRY_CODE;

    this.setState({ loading: true });
    const onDone = () => {
      if (this.isMounted()) {
        this.setState({ loading: false });
      }
    };

    return PaymentAccountActions.patch(value)
      .then(this.props.onVerified, onFailure)
      .then(onDone, onDone);
  },

  render() {
    return (
      <div className="IdentityVerificationView">
        <Container size="medium">
          <Form
            className="IdentityVerificationView-form"
            onValid={() => this.setState({ disabled: false })}
            onInvalid={() => this.setState({ disabled: true })}
            onValidSubmit={this.handleFormSubmit}>
            <div className="IdentityVerificationView-inputs">
              <div className="IdentityVerificationView-columns IdentityVerificationView-columns2">
                <div>
                  <FormInput
                    label="First name"
                    required
                    name="first_name"
                    validations={{ maxLength: 60 }}
                    validationErrors={{
                      maxLength: 'First Name can’t be longer than 60 characters',
                      isDefaultRequiredValue: 'First name is required',
                    }}
                  />
                </div>

                <div>
                  <FormInput
                    label="Last name"
                    required
                    name="last_name"
                    validations={{ maxLength: 60 }}
                    validationErrors={{
                      maxLength: 'Last Name can’t be longer than 60 characters',
                      isDefaultRequiredValue: 'Last name is required',
                    }}
                  />
                </div>
              </div>

              <div className="IdentityVerificationView-columns">
                <FormInput
                  label="Address"
                  required
                  name="address[line1]"
                  validationErrors={{
                    isDefaultRequiredValue: 'Address is required',
                  }}
                />
              </div>

              <div className="IdentityVerificationView-columns IdentityVerificationView-columns3">
                <div className="IdentityVerificationView-columns3-city">
                  <FormInput
                    label="City"
                    required
                    name="address[city]"
                    validations={{ maxLength: 60 }}
                    validationErrors={{
                      maxLength: 'City can’t be longer than 60 characters',
                      isDefaultRequiredValue: 'City is required',
                    }}
                  />
                </div>

                <div className="IdentityVerificationView-columns3-state">
                  <FormSelect
                    label="State"
                    required
                    name="address[state]"
                    placeholder=""
                    options={USState}
                    inputProps={{ maxLength: 12 }}
                    validationErrors={{
                      isDefaultRequiredValue: 'Please select a state',
                    }}
                  />
                </div>

                <div className="IdentityVerificationView-columns3-zipcode">
                  <FormInput
                    label="ZIP code"
                    required
                    name="address[postal_code]"
                    autoComplete="postal-code"
                    className="postal-code"
                    validations={{ maxLength: 60 }}
                    validationErrors={{
                      maxLength: 'ZIP code can’t be longer than 60 characters',
                      isDefaultRequiredValue: 'ZIP code is required',
                    }}
                  />
                </div>
              </div>
              <div className="IdentityVerificationView-dateandssn">
                <div className="IdentityVerificationView-dateandssn-date">
                  <div>
                    <Label>Date of birth</Label>
                    <Label hidden aria-label="Month" />
                    <FormMonthSelect
                      required
                      name="dob[month]"
                      autoComplete="bday-month"
                      placeholder="Month"
                      className="bday-month"
                      inputProps={{ maxLength: 2 }}
                      validationErrors={{
                        isDefaultRequiredValue: 'Please select a month',
                      }}
                    />
                  </div>

                  <div>
                    <Label aria-label="Day" />
                    <FormDaySelect
                      required
                      name="dob[day]"
                      autoComplete="bday-day"
                      placeholder="Day"
                      className="bday-day"
                      inputProps={{ maxLength: 2 }}
                      validationErrors={{
                        isDefaultRequiredValue: 'Please select a day',
                      }}
                    />
                  </div>

                  <div>
                    <Label aria-label="Year" />
                    <FormYearSelect
                      required
                      name="dob[year]"
                      autoComplete="bday-year"
                      inputProps={{ maxLength: 4 }}
                      placeholder="Year"
                      className="bday-year"
                      validationErrors={{
                        isDefaultRequiredValue: 'Please select a year',
                      }}
                    />
                  </div>
                </div>
                <div className="IdentityVerificationView-dateandssn-ssn">
                  <FormInput
                    label="Last 4 digits of SSN"
                    required
                    name="ssn"
                    showErrorAfterBlur
                    maxLength={4}
                    validations={{ isLength: 4 }}
                    validationErrors={{
                      isLength: 'SSN must be 4 characters',
                      isDefaultRequiredValue: 'Last 4 digits of SSN is required',
                    }}
                  />
                </div>
              </div>
            </div>
            <Button
              loading={this.state.loading}
              className="IdentityVerificationView-submit"
              disabled={this.state.disabled}
              eventScreenName={EventTrackingConstants.CREATE_DEPOSIT_ADDRESS}
              eventElementName="continue">
              Continue
            </Button>
          </Form>
          <EncryptionNotice />
        </Container>
      </div>
    );
  },
});

export default IdentityVerificationView;



// WEBPACK FOOTER //
// ./src/payments/components/IdentityVerificationView.jsx